import React from "react";
import { Link } from "../../common/components/link";
import { links } from "../../routes";

interface Props {
    idCliente: number
}
export const NewImpiantoWidget = (props: Props) => {
    const { idCliente } = props;

    return (
        <div className="card m-2" style={{ minHeight: 150 }}>
            <div className="card-body d-flex flex-column align-items-center justify-content-center ps-5 pe-5">
                <div className="d-flex align-items-center mb-3">
                    <i className="fas fa-plus fa-3x text-theme" />
                </div>
                <Link className="stretched-link text-uppercase text-muted fw-bold" to={links.impiantoSelection(idCliente)}>Nuovo Impianto</Link>
            </div>
        </div>
    );
};